import React from "react";
import { NumericFormat } from "react-number-format";

const Percent = props => {
  const { valueChange, value, disabled, required } = props;
  // const _value = value || "";

  return (
    <NumericFormat
      data-required={required}
      data-required-valid={required && !!value}
      fixedDecimalScale={true}
      disabled={disabled}
      placeholder="0,00 %"
      suffix={" %"}
      thousandSeparator="."
      thousandsGroupStyle="thousand"
      decimalSeparator=","
      decimalScale={2}
      onChange={__ev => {
        let _value = __ev.target.value;
        _value = _value.replaceAll(" %", "").replaceAll(".", "").replaceAll(",", ".");
        _value = parseFloat(_value || 0);
        valueChange(_value);
      }}
      onKeyPress={__ev => {
        __ev.key === "Enter" && __ev.target.blur();
      }}
      {...props}
      value={value || null}
    />
  );
};

export default Percent;
